import { render, staticRenderFns } from "./mobileH5.vue?vue&type=template&id=6266cb7e&scoped=true&"
import script from "./mobileH5.vue?vue&type=script&lang=js&"
export * from "./mobileH5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6266cb7e",
  null
  
)

export default component.exports